import React from 'react'
import classNames from 'classnames'
import './styles.css'

const PageTitle = (props) => {
    const Heading = props.minor ? 'h2' : 'h1'

    const className = classNames('page-title', {
        'page-title-standalone': props.standalone,
        'page-title-standalone-minor': props.standaloneMinor,
    })

    return (
        <Heading className={className} style={props.style}>
            {props.children}
        </Heading>
    )
}

export default PageTitle
